require('./OKSwitch.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @ commons
const { FormattedText } = require('core/i18n').i18n;

// @constants
const OKSWITCH_EMPTY_VALUE = null;
const OKSWITCH_NEGATIVE_VALUE = false;
const OKSWITCH_POSITIVE_VALUE = true;

class OKSwitch extends React.Component {

    constructor(props) {
        super(props);

        this.handleToggleValue = this.handleToggleValue.bind(this);
    }

    // If the component receives as props the values to be used as Positive, Negative and Neutral,
    // it uses those values when changing status of switch. If not, it uses default prop values.
    handleToggleValue() {
        const {
            negativeValue,
            neutralValue,
            positiveValue
        } = this.props;
        let newValue = neutralValue;

        switch(this.props.value){
            case positiveValue:
                newValue = negativeValue;
                break;
            default:
                newValue = positiveValue;
                break;
        }
        this.props.onChange(newValue);
    }

    buildButtons() {
        const {
            negativeValue,
            positiveValue,
            onChange,
            value
        } = this.props;
        let response;

        if (value === positiveValue) {
            response = (
                <div className="ok-switch__positive-button">
                    <FormattedText value="common-yes" />
                </div>
            );
        } else if (value === negativeValue) {
            response = (
                <div className="ok-switch__negative-button">
                    <FormattedText value="common-no" />
                </div>
            );
        } else {
            response = (
                <div>
                    <div
                        className="ok-switch__switch-negative-button"
                        onClick={() => onChange(negativeValue)}
                    >
                        <FormattedText value="common-no" />
                    </div>
                    <div className="ok-switch__switch-button" />
                    <div
                        className="ok-switch__switch-positive-button"
                        onClick={() => onChange(positiveValue)}
                    >
                        <FormattedText value="common-yes" />
                    </div>
                </div>
            );
        }

        return response;
    }

    render() {
        const {
            className,
            modifier,
            negativeValue,
            neutralValue,
            positiveValue,
            value
        } = this.props;
        const handleFn = value !== neutralValue ? this.handleToggleValue : null;
        const okSwitchClassNames = classNames(`ok-switch ${className}`, {
            [`ok-switch--${modifier}`]: modifier,
            'ok-switch--empty': ![positiveValue, negativeValue].includes(value),
            'ok-switch--positive': value === positiveValue,
            'ok-switch--negative': value === negativeValue
        });

        return (
            <div className={okSwitchClassNames} onClick={handleFn}>
                {this.buildButtons()}
            </div>
        );
    }
}

OKSwitch.propTypes = {
    className: PropTypes.string,
    modifier: PropTypes.oneOf(['']),// Not yet used, but ready for whenever it's necessary
    negativeValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    neutralValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    onChange: PropTypes.func.isRequired,
    positiveValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

OKSwitch.defaultProps = {
    className: '', // Use this prop to add additional classNames to the component
    modifier: '', // Use this prop along with css to, for example, change colors of the component
    negativeValue: OKSWITCH_NEGATIVE_VALUE,
    neutralValue: OKSWITCH_EMPTY_VALUE,
    positiveValue: OKSWITCH_POSITIVE_VALUE,
    value: OKSWITCH_EMPTY_VALUE
};

module.exports = OKSwitch;
